<template>
  <div class="content-editor-block content">
    <div @input="onInput" v-html="initValue" ref="input"></div>
    <!-- <el-input v-model="mValue" @input="onInput" type="textarea" autosize placeholder="請輸入內文"></el-input> -->
  </div>
</template>

<script>
import MediumEditor from 'medium-editor'
import { ColorPickerExtension } from '@/utils/medium-editor/medium-editor-color-picker.js'
export default {
  props: {
    value: {
      default: ''
    }
  },
  data: () => {
    return {
      initValue: '',
      mValue: '',
      editor: null
    }
  },
  computed: {
  },
  methods: {
    onInput () {
      this.mValue = this.$refs.input.innerHTML
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.initValue = this.value
    this.mValue = this.value
  },
  mounted () {
    let opts = {
      toolbar: {
        buttons: ['bold', 'italic', 'underline', 'strikethrough', 'colorPicker'],
        align: 'left'
      },
      placeholder: {
        text: '請輸入內文',
        hideOnClick: false
      },
      keyboardCommands: {
        commands: [
          {
            command: 'bold',
            key: 'B',
            meta: true,
            shift: false,
            alt: false
          },
          {
            command: 'italic',
            key: 'I',
            meta: true,
            shift: false,
            alt: false
          },
          {
            command: 'underline',
            key: 'U',
            meta: true,
            shift: false,
            alt: false
          }
        ]
      },
      imageDragging: false,
      paste: {
        forcePlainText: true,
        cleanPastedHTML: false,
        cleanReplacements: [],
        cleanAttrs: ['class', 'style', 'dir'],
        cleanTags: ['label', 'meta'],
        unwrapTags: ['sub', 'sup']
      },
      extensions: {
        'colorPicker': new ColorPickerExtension()
      }
    }
    this.editor = new MediumEditor(this.$refs.input, opts)
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
